export const SUPERVPN_APK_URL = 'https://apk.secureproxyvpn.com/android/apk/SecureVPN-release-1.0.2_c-20260710171019.apk';
